import React from "react";

import * as typography from "@client/shared/typography";

import {Layout} from "@client/site/Layout";
import * as forms from "@client/site/forms";
import {reverse, server} from "@reactivated";

export const Template = (props: server.manager.templates.ConfirmManager) => {
    return (
        <Layout narrow title="Confirm manager">
            <form
                noValidate
                method="POST"
                action=""
                className="flex flex-col space-y-[15px]"
            >
                <forms.CSRFToken />
                <typography.Header>Confirm manager</typography.Header>

                <typography.P>Please fill out the details below.</typography.P>
                <typography.P>
                    Upon submission, you will confirm{" "}
                    <strong>{props.manager.email}</strong> as your manager.
                    <br />
                    They will have full access to your journal, reports and all other
                    metrics.
                </typography.P>
                <forms.Fields form={props.profile_form} fields={["email", "name"]} />
                <div
                    className="
                        m-[-5px] flex flex-wrap items-end
                        *:m-[5px]
                    "
                >
                    <forms.Fields
                        form={props.profile_form}
                        fields={["date_of_birth", "gender", "zip_code"]}
                    />
                </div>
                {props.is_registering === true && (
                    <>
                        <typography.Header>Pick a password</typography.Header>
                        <forms.Fields form={props.password_form} />
                    </>
                )}

                <typography.P>
                    By clicking confirm, you agree to our{" "}
                    <typography.A href={reverse("terms_of_service")}>
                        terms of service
                    </typography.A>
                    .
                </typography.P>
                <typography.Button submit>Confirm</typography.Button>
            </form>
        </Layout>
    );
};
